import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class RmBomItemRequest {

    @ApiProperty()
    productId: number;

    @ApiProperty()
    count: number;

    
    @ApiProperty()
    isActive?: boolean;
}